import React from 'react'

import Icon from '@/components/common/Icon'

const IconHSBC: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 21 6"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4992 2.93017H12.4976V3.91688H11.9893V1.59961H12.4976V2.54147H13.4992V1.59961H14.0075V3.91688H13.4992V2.93017Z"
      fill="black"
    />
    <path
      d="M15.2189 3.96234C14.7255 3.96234 14.3069 3.76799 14.292 3.21483H14.8003C14.8003 3.46898 14.9498 3.60354 15.2339 3.60354C15.4432 3.60354 15.6674 3.49888 15.6674 3.27463C15.6674 3.09523 15.503 3.03543 15.2488 2.96068L15.0844 2.91583C14.7255 2.81118 14.3518 2.66167 14.3518 2.25802C14.3518 1.73476 14.8302 1.57031 15.2787 1.57031C15.7272 1.57031 16.1159 1.73476 16.1159 2.24307H15.6076C15.5927 2.03377 15.4731 1.91417 15.2339 1.91417C15.0545 1.91417 14.8601 2.01882 14.8601 2.21317C14.8601 2.37762 15.0096 2.43742 15.3385 2.54207L15.5329 2.60187C15.9365 2.72148 16.1757 2.87098 16.1757 3.24473C16.1757 3.76799 15.6674 3.96234 15.2189 3.96234Z"
      fill="black"
    />
    <path
      d="M16.4593 1.59961H17.2666C17.5207 1.59961 17.6254 1.59961 17.7151 1.62951C17.9992 1.68931 18.2085 1.88366 18.2085 2.18267C18.2085 2.48167 18.0141 2.63117 17.745 2.70592C18.059 2.76572 18.2832 2.93017 18.2832 3.27403C18.2832 3.79728 17.76 3.91688 17.3563 3.91688H16.4443V1.59961H16.4593ZM17.2666 2.57137C17.4908 2.57137 17.7151 2.52652 17.7151 2.25742C17.7151 2.01821 17.5058 1.95841 17.2965 1.95841H16.9377V2.57137H17.2666ZM17.3264 3.57303C17.5656 3.57303 17.7899 3.51323 17.7899 3.22918C17.7899 2.96007 17.5955 2.88532 17.3563 2.88532H16.9526V3.55808H17.3264V3.57303Z"
      fill="black"
    />
    <path
      d="M19.6138 3.96166C18.8663 3.96166 18.5225 3.48326 18.5225 2.7806C18.5225 2.07794 18.8962 1.55469 19.6288 1.55469C20.0922 1.55469 20.5407 1.76399 20.5557 2.28725H20.0324C20.0025 2.06299 19.853 1.92844 19.6288 1.92844C19.1803 1.92844 19.0457 2.4218 19.0457 2.7806C19.0457 3.15436 19.1803 3.57296 19.6138 3.57296C19.8381 3.57296 20.0025 3.45336 20.0474 3.21416H20.5706C20.5108 3.76731 20.0922 3.96166 19.6138 3.96166Z"
      fill="black"
    />
    <path d="M8.29719 0H2.76562V5.53156H8.29719V0Z" fill="white" />
    <path
      d="M8.3125 5.53156L11.0783 2.76578L8.3125 0V5.53156Z"
      fill="#DB0011"
    />
    <path d="M2.76578 5.53156L0 2.76578L2.76578 0V5.53156Z" fill="#DB0011" />
    <path d="M8.31214 0L5.53141 2.76578L2.76562 0H8.31214Z" fill="#DB0011" />
    <path
      d="M2.76562 5.53141L5.53141 2.76562L8.31214 5.53141H2.76562Z"
      fill="#DB0011"
    />
  </svg>
)

export default Icon(IconHSBC)
